import { render, staticRenderFns } from "./educational.vue?vue&type=template&id=0db0bb0c&scoped=true&"
import script from "./educational.vue?vue&type=script&lang=js&"
export * from "./educational.vue?vue&type=script&lang=js&"
import style0 from "./educational.vue?vue&type=style&index=0&id=0db0bb0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db0bb0c",
  null
  
)

export default component.exports